const PARAGRAPH_KIND = Object.freeze({
    SPEAKER: "speaker",
    UNLABELED: "unlabeled",
});

const PARAGRAPH_AFFINITY = Object.freeze({
    PREVIOUS: "previous",
    NEXT: "next",
});

const DEFAULT_PARAGRAPH_LAYOUT_BEHAVIOR = Object.freeze({
    affinity: PARAGRAPH_AFFINITY.PREVIOUS,
    breakBefore: false,
    breakAfter: false,
    breakBeforeReason: null,
    breakAfterReason: null,
    breakBeforeStrength: null,
    breakAfterStrength: null,
    isolateInOwnParagraph: false,
    paragraphKind: null,
    speakerInfoOverride: null,
});

function buildParagraphLayoutBehavior(baseBehavior, overrides){
    return Object.assign({}, DEFAULT_PARAGRAPH_LAYOUT_BEHAVIOR, baseBehavior || {}, overrides || {});
}

function normalizeParagraphLayoutBehavior(paragraphBehavior){
    const normalizedBehavior = buildParagraphLayoutBehavior(null, paragraphBehavior);
    if(
        normalizedBehavior.affinity !== PARAGRAPH_AFFINITY.PREVIOUS
        && normalizedBehavior.affinity !== PARAGRAPH_AFFINITY.NEXT
    ){
        normalizedBehavior.affinity = PARAGRAPH_AFFINITY.PREVIOUS;
    }
    if(
        normalizedBehavior.paragraphKind !== PARAGRAPH_KIND.SPEAKER
        && normalizedBehavior.paragraphKind !== PARAGRAPH_KIND.UNLABELED
    ){
        normalizedBehavior.paragraphKind = null;
    }
    return normalizedBehavior;
}

function createParagraphLayoutBehavior(overrides){
    return normalizeParagraphLayoutBehavior(overrides);
}

function extendParagraphLayoutBehavior(baseBehavior, overrides){
    return normalizeParagraphLayoutBehavior(buildParagraphLayoutBehavior(baseBehavior, overrides));
}

const ParagraphLayoutBehavior = {
    KIND: PARAGRAPH_KIND,
    AFFINITY: PARAGRAPH_AFFINITY,
    DEFAULTS: DEFAULT_PARAGRAPH_LAYOUT_BEHAVIOR,
    create: createParagraphLayoutBehavior,
    extend: extendParagraphLayoutBehavior,
    normalize: normalizeParagraphLayoutBehavior,
    presets: {
        associateWithNextParagraph: function(baseBehavior, overrides){
            return extendParagraphLayoutBehavior(baseBehavior, Object.assign({
                affinity: PARAGRAPH_AFFINITY.NEXT,
            }, overrides || {}));
        },

        startUnlabeledParagraph: function(baseBehavior, overrides){
            return extendParagraphLayoutBehavior(baseBehavior, Object.assign({
                breakBefore: true,
                paragraphKind: PARAGRAPH_KIND.UNLABELED,
            }, overrides || {}));
        },

        endUnlabeledParagraph: function(baseBehavior, overrides){
            return extendParagraphLayoutBehavior(baseBehavior, Object.assign({
                breakAfter: true,
                paragraphKind: PARAGRAPH_KIND.UNLABELED,
            }, overrides || {}));
        },

        isolatedUnlabeledParagraph: function(baseBehavior, overrides){
            return extendParagraphLayoutBehavior(baseBehavior, Object.assign({
                isolateInOwnParagraph: true,
                paragraphKind: PARAGRAPH_KIND.UNLABELED,
            }, overrides || {}));
        },
    },
};

module.exports = ParagraphLayoutBehavior;
